import { useGetHtmlTag } from 'root/hooks/useGetHtmlTag';
import { useStyles } from '@wix/tpa-settings/react';
import stylesParams from 'root/components/Menus/stylesParams';
import { useMenusContext } from 'root/contexts/MenusContext';
import { ChevronDown, ChevronUp, Minus, Plus } from '@wix/wix-ui-icons-common/on-stage';
import { ExpandCollapseIcon } from 'root/consts';
import React, { useState, useRef, useEffect } from 'react';
import { hasSectionImage } from 'root/utils/presets';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { useSectionRefs } from 'root/contexts/SectionRefsContext';

export const useSectionLogic = (sectionId: string, isFirstSection?: boolean) => {
  const { isEditor } = useMenusContext();
  const sectionTitleHtmlTag = useGetHtmlTag('sectionTitleTheme');
  const sectionDescriptionHtmlTag = useGetHtmlTag('sectionDescriptionTheme');
  const styles = useStyles();
  const { t } = useTranslation();
  const { registerSectionRef } = useSectionRefs();

  const preset = styles.get(stylesParams.preset);
  const showSectionImage = styles.get(stylesParams.showSectionImage) && hasSectionImage(preset);
  const [sectionCollapsed, setSectionCollapsed] = useState<boolean>(isEditor && isFirstSection ? false : true);
  const expandIcon = styles.get(stylesParams.sectionExpandCollapseIcon);

  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    registerSectionRef(sectionId, sectionRef);
  }, [sectionId, registerSectionRef]);

  return {
    sectionTitleHtmlTag,
    sectionDescriptionHtmlTag,
    sectionCollapsed,
    setSectionCollapsed,
    icons:
      expandIcon === ExpandCollapseIcon.Plus
        ? { expanded: <Minus />, collapsed: <Plus /> }
        : { expanded: <ChevronUp />, collapsed: <ChevronDown /> },
    showSectionImage,
    t,
    sectionRef,
  };
};
